import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import {
  SupportMessageBodyInterface,
  SupportService,
} from '../../../shared/services/support.service';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { AppStateInterface } from '../../../store/state/app.state';
import { setEventId } from '../../../store/actions/profile.actions';
import { ClickhouseService } from '../../../shared/services/clickhouse.service';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-support',
  templateUrl: './support.component.html',
  styleUrls: ['./support.component.scss'],
})
export class SupportComponent implements OnInit {
  supportForm: FormGroup;

  messageSent = false;

  constructor(
    private supportService: SupportService,
    private activatedRoute: ActivatedRoute,
    private store: Store<AppStateInterface>,
    private clickHouse: ClickhouseService,
    private spinner: NgxSpinnerService,
  ) {
    this.supportForm = new FormGroup({
      nameControl: new FormControl('', [Validators.required, Validators.minLength(5)]),
      emailControl: new FormControl('', [
        Validators.required,
        Validators.pattern(/^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,5}$/),
      ]),
      reasonControl: new FormControl('', [Validators.required]),
      textControl: new FormControl('', [Validators.required, Validators.minLength(15)]),
    });
  }

  ngOnInit(): void {
    if (this.activatedRoute.snapshot.queryParams.eventid) {
      this.store.dispatch(
        setEventId({ eventId: this.activatedRoute.snapshot.queryParams.eventid }),
      );
    }
    this.clickHouse
      .storeEvent(
        'support_page_visit',
        this.activatedRoute.snapshot.queryParams.sourcesite || 'webapp',
      )
      .subscribe(() => {});
  }

  sendSupport() {
    if (this.supportForm.valid) {
      this.spinner.show();
      let supportRequestObject: SupportMessageBodyInterface = {
        reason: this.supportForm.value.reasonControl,
        message: this.supportForm.value.textControl,
        user_name: this.supportForm.value.nameControl,
        response_mail: this.supportForm.value.emailControl,
      };
      if (
        this.activatedRoute.snapshot.queryParams.eventid &&
        this.activatedRoute.snapshot.queryParams.sourcesite
      ) {
        supportRequestObject.event_id = this.activatedRoute.snapshot.queryParams.eventid;
        supportRequestObject.source = this.activatedRoute.snapshot.queryParams.sourcesite;
      }
      this.supportService.sendSupportMessage(supportRequestObject).subscribe(() => {
        this.messageSent = true;
        this.spinner.hide();
      });
    }
  }

  auto_grow(event: any) {
    event.target.style.height = '5px';
    event.target.style.height = event.target.scrollHeight + 5 + 'px';
  }

  toLowerCase() {
    this.supportForm
      .get('emailControl')
      ?.setValue(this.supportForm.controls.emailControl.value.toLowerCase());
  }
}
